module.exports = "<md-content layout=\"row\">\r\n    <span flex></span>\r\n    <md-button class=\"image-button\" aria-label=\"{{okText}}\" ng-click=\"okAction()\">\r\n        <md-icon md-font-icon=\"ion-checkmark\"></md-icon>\r\n        <span class=\"image-button-label\">{{okText}}</span>\r\n    </md-button>\r\n    <md-button class=\"image-button\" aria-label=\"{{cancelText}}\" ng-click=\"cancelAction()\">\r\n        <md-icon md-font-icon=\"ion-close\"></md-icon>\r\n        <span class=\"image-button-label\">{{cancelText}}</span>\r\n    </md-button>\r\n</md-content>"


//////////////////
// WEBPACK FOOTER
// ./client/app/core/confirmbuttons.directive.html
// module id = 1078
// module chunks = 1